const jsAOP = {
  /**
   * target aspect target
   * method aspect target function
   * advice aspect point function
   * **/
  before: function (target, method, advice) {
    //store the original function
    let original = target[method];
    target[method] = function () {
      //(advice)(); //changed to use advice.apply to pass a parameter from the target function
      advice.apply(target, arguments);
      original.apply(target, arguments);
    };
    return target;
  },
  after: function (target, method, advice) {
    let original = target[method];
    target[method] = function () {
      original.apply(target, arguments);
      //(advice)();
      advice.apply(target, arguments);
    };
    return target;
  },
  around: function (target, method, advice) {
    let original = target[method];
    target[method] = function () {
      //(advice[0])();
      advice[0].apply(target, arguments);
      original.apply(target, arguments);
      //(advice[1])();
      advice[1].apply(target, arguments);
    };
    return target;
  },
};
export default jsAOP;

export function GoogleTagManager(func, eve, parameter) {
  function CommonEvent() {}

  CommonEvent.prototype.onClick = func;

  let commonEvent = new CommonEvent();
  commonEvent = jsAOP.before(commonEvent, 'onClick', function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eve, ...parameter });
  });

  return commonEvent.onClick;
}

export function CatchEmptyTextColorLocation(func, color, callback) {
  function CommonEvent() {}

  CommonEvent.prototype.onClick = func;

  let commonEvent = new CommonEvent();
  commonEvent = jsAOP.after(commonEvent, 'onClick', function () {
    if (color === null || color === undefined) {
      callback && callback();
    }
  });

  return commonEvent.onClick;
}
